import React, { FunctionComponent } from "react"
import FancyLoader from "src/components/common/Loaders/FancyLoader/FancyLoader"
import "./PromotingOrDemotingLoader.css"

interface Props {
    updateUserAction: number
}

const PromotingOrDemotingLoader: FunctionComponent<Props> = (props) => {
    const { updateUserAction } = props
    const promoting = updateUserAction > 0

    return (
        <div className="PromotingOrDemotingLoader">
            <FancyLoader
                className="FancyLoaderLock"
                id="eala-promoting-or-demoting-loader"
            />
            <div className={`PromotingOrDemotingLoaderAction ${promoting ? "PromotingOrDemotingLoaderActionPromotion" : "PromotingOrDemotingLoaderActionDemotion"}`}>
                <span className="material-icons-outlined">{`${promoting ? "arrow_upward" : "arrow_downward"}`}</span>
            </div>
        </div>
    )
}

export default PromotingOrDemotingLoader